const yue_Hans_CN = {
  restartInterviewButton: "重新开始",
  restartInterviewConfirmTitle: "重新开始访谈？",
  restartInterviewConfirmDescription: "会开启一次新嘅访谈，唔会接住而家嘅进度继续。已有记录会保留。",
  restartInterviewCancel: "取消",
  restartInterviewFailed: "未能重新开始访谈，请稍后再试",
  restartInterviewLimitReached: "访谈名额已满，无法重新开始。",
  restartInterviewClosed: "访谈已经关闭，唔可以重新开始。",
  restartInterviewCutoff: "访谈已经过咗截止时间，唔可以重新开始。",
  interviewLoading: "正在加载访谈…",
  interviewLinkInvalid: "访谈链接无效",
  interviewLoadFailed: "加载访谈失败，请稍后再试",
  interviewRetry: "重试",
  saveInfoFailed: '未能保存资料，请再试一次',
  loadLatestInterviewFailed: '未能加载最新访谈记录，请稍后再试',
  interviewProgressSaved: '访谈进度唔会流失',
  previousStimulus: '上一个概念',
  nextStimulus: '下一个概念',
  expandStimulus: '放大概念',
  closeStimulusPreview: '关闭概念预览',
  stimulusPreview: '概念预览',
  imageTooLarge: '图片大小唔可以超过 10 MB',
  imageFormatJpegPngOnly: '只支持 PNG、JPEG 同 JPG 格式嘅图片',
  imageFilesOnly: '只可以上传图片文件',
  imageUploadFailed: '未能上传图片，请再试一次',
  finalUploadFailed: '未能上传文件，请再试一次',
  Welcome: '欢迎嚟到访谈',
  StartInterview: '开始访谈',
  Submit: '提交',
  Stoprecording: '停止回复',
  Aiinterviewer: '访谈人',
  AiModeratedInterview: 'AI主持访谈',
  TalkToAva: '同 Ava 倾偈',
  microphoneAccessTitle: '允许使用麦克风',
  microphoneAccessDescription: 'Ava 需要使用你嘅麦克风，方便进行自然嘅语音对话。',
  microphoneAllow: '允许使用麦克风',
  microphoneNotNow: '暂不',
  microphoneConnectedTitle: '麦克风已连接',
  microphoneConnectedDescription: '一切就绪，Ava 已准备好倾听。',
  microphoneDeniedTitle: '需要麦克风权限',
  microphoneDeniedDescription: '请喺浏览器设置中允许麦克风访问，然后重试。',
  microphoneTryAgain: '重试',
  VoiceAnswer: '语音回复',
  TextAnswer: '文字回复',
  StudyMainTitle: '正式访谈之前，我哋会先做一次筛选',
  StudyMainTip: '唔好意思，你唔系今次访谈嘅目标群体，未能参与今次访谈',
  // ThankYou: '多谢',
  //
  TitleTop: '快啲嚟倾下啦',
  HeardVoice: '你嘅声音值得被听见、被鼓励！',
  Sophie: '同 Ava 做一次简短访谈啦',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: '开始一段简短聊天并获得专属',
  Dollars: '属于你嘅 CHIMOJI 奖励！',
  // Progress: 'the progress of this chat',
  Congrats: '恭喜完成！',
  ThankYou: '多谢你分享见解',
  Refresh: '刷新本页唔会遗失聊天进度',
  Carousel: '因应网络状况，可能会有轻微延迟',
  CheckOut: '你都想建立呢类访谈？睇下 ',
  Rewarded: '如果你想获得奖励，访谈人需要了解你嘅资料 ',
  InterviewerReward: '呢个系访谈人俾你嘅奖励 ',
  Register: '登录/注册成为',
  Insighteer: 'INSIGHTEER',
  Reward: '以获取专属奖励',
  CreatePassword: '建立密码完成注册',
  Becoming: '加入我哋啦！',
  Password: '请输入你嘅密码！',
  ChooseTopic: '拣一个你感兴趣嘅话题',
  Identity: '你系...',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: '关注我哋',
  Unique: '呢个独一无二、专属于你嘅 CHIMOJI 会连同今次访谈一齐记录喺区块链上',
  Next: '下一步',
  ViewRewards: '查看奖励',
  endMeg1: '请喺呢度留下你嘅电邮，方便我哋传送语音回放俾你',
  endMeg2: '请喺呢度留下你嘅资料，以获取今次访谈建立者嘅奖励',
  endMeg3: '请喺呢度留下你嘅资料俾今次访谈',
  endMsg5: '请喺呢度留下你嘅资料以获取',
  endMsg6: '你嘅 MBTI 测试结果',
  Done: '提交',
  Done1: '完成',
  GetIncentives: '获取奖励',
  GetStartedFreeNow: '立即免费开始',
  UniqueChimojiNFT: '独特嘅 Chimoji NFT',
  endMsg4: '想建立自己嘅访谈？',
  ResumeInterview: '点击继续访谈',
  interviewPausedTitle: '访谈已暂停',
  interviewPausedDescription: '你的访谈进度已保存，准备好后可以随时继续。',
  resumeInterviewButton: '恢复访谈',
  pauseInterview: '暂停',
  pauseInterviewConfirmTitle: '暂停访谈？',
  pauseInterviewConfirmContent: '当前进度会保留，之后可以继续访谈。',
  pauseInterviewConfirmOk: '暂停',
  pauseInterviewConfirmCancel: '继续访谈',
  poorConnection: '连接不佳',
  connectionReconnectingTitle: '正在重新连接…',
  connectionReconnectingDescription: '请保持呢个页面打开，Ava 正在恢复连接。',
  connectionReconnectedTitle: '已重新连接',
  connectionReconnectedDescription: '网络已恢复，正在继续访谈。',
  connectionDisconnectedTitle: '连接已断开',
  connectionDisconnectedDescription: '你嘅访谈进度已保存。',
  refresh: '刷新页面唔会遗失进度',
  voiceSnapshot: '语音快照',
  fromInterview: '嚟自 AI Ava 对我嘅访谈',
  findMore: '喺 chikka.ai 了解更多',
  msg1: '同 AVA 倾偈，5 分钟内测试你嘅 MBTI',
  speaking: '你正在讲嘢...',
  avaSpeaking: 'AVA 正在讲嘢...',
  avaListening: 'AVA 正在听...',
  stimuliConversationWithAva: '你正同 Ava 进行对话',
  stimuliReviewConcepts: '请仔细查看下面嘅概念内容，并回答 Ava 嘅问题。',
  stimuliSwipeInstruction: '左右滑动以查看全部概念内容。',
  stimuliFullscreenInstruction: '双击图片可以全屏查看。',
  finalUploadTitleFallback: '上传文件',
  finalUploadInstructionFallback: '结束访谈前请先上传文件',
  finalUploadTap: '点击上传',
  finalUploadHelp: '你嘅文件可以帮助我哋更好理解你嘅体验。',
  finalUploadLimit: '最多 10 个文件',
  finalUploadSubmit: '提交',
  finalUploadSkip: '跳过',
  finalUploadWait: '请等待所有文件上传完成',
}
export default yue_Hans_CN
